export default __webpack_public_path__ + "static/media/RoutePage1.7a7a4ea0.txt";